import { render, staticRenderFns } from "./AddTicks.vue?vue&type=template&id=59b40424&scoped=true"
import script from "./AddTicks.vue?vue&type=script&lang=js"
export * from "./AddTicks.vue?vue&type=script&lang=js"
import style0 from "./AddTicks.vue?vue&type=style&index=0&id=59b40424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b40424",
  null
  
)

export default component.exports